/**
 * The four G/L account classes a ledger account can be assigned to.
 * @see https://app.dev.vestigas.com/redoc#tag/Ledger-Accounts
 */
export const LEDGER_ACCOUNT_TYPE = [
  'asset',
  'liability',
  'revenue',
  'expense',
] as const;

/**
 * Whether a ledger account version was entered by hand or came from an import.
 */
export const LEDGER_ACCOUNT_SOURCE_TYPE = ['web_manual', 'web_upload'] as const;
